import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Performanță',
    [Tab.NewCustomers]: 'Restaurante noi',
    [Tab.CustomerHealth]: 'Sănătate clienți',
    [Tab.LiveAndInactive]: 'Active și inactive',
    [Tab.BillingHealth]: 'Sănătate facturare',
  },
  labels: {
    sales_manager: 'Manager vânzări',
  },
  performance_tab: {
    table_columns: {
      name: 'Nume',
      sales_manager: 'Manager vânzări',
      orders: 'Comenzi',
      sales: 'Vânzări',
      previous_month_sales: 'Venituri luna precedentă',
    },
    labels: {
      sales_volume: 'Volum vânzări:',
      all: 'Toate',
      click_to_sort: 'Clic pentru sortare',
      no_data: 'Fără date',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea datelor',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nume',
      sales_manager: 'Manager vânzări',
      orders: 'Comenzi',
      sales: 'Vânzări',
      days_live: 'Zile active',
      early_performance: 'Performanță timpurie',
    },
    labels: {
      click_to_sort: 'Clic pentru sortare',
      no_data: 'Fără date',
      only_with_early_performance: 'Doar cu performanță timpurie: ',
      early_performance_yes: '✔️ Da',
      early_performance_no: '✗ Nu',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea datelor',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Niveluri vânzări',
      payments_ratio: 'Rată plăți',
    },
    dataset_labels: {
      negative: 'Negativ ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Bun ({{values}})',
      excellent: 'Excelent ({{values}})',
    },

    companies_preview_modal: {
      title: 'Previzualizare restaurante',
      table_columns: {
        name: 'Nume',
        sales_manager: 'Manager vânzări',
        orders: 'Comenzi',
        sales: 'Vânzări',
        total_payments: 'Total plăți',
        payments_ratio: 'Rată plăți',
      },
      labels: {
        close: 'Închide',
        click_to_sort: 'Clic pentru sortare',
        no_data: 'Fără date',
      },
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea datelor',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Activ',
      no_orders: 'Fără comenzi',
      no_conversion: 'Fără conversie',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea datelor',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Tip facturare',
        options: {
          [BillingTypeOptions.Subscription]: 'Abonament',
          [BillingTypeOptions.Manual]: 'Altul',
        },
      },
      high_risk_only: {
        label: 'Doar clienți cu risc ridicat',
      },
    },
    fields: {
      name: 'Nume',
      live_from: 'Activ din',
      billing_mode: {
        title: 'Sursă facturare',
        options: {
          [BillingMode.Stripe]: 'Metodă de plată',
          [BillingMode.InternalInvoicing]: 'Vânzări',
        },
      },
      trial_ends_at: 'Sfârșit probă',
      last_failed_invoice_amount: 'Suma ultimei facturi eșuate',
      failed_payments_count: 'Număr plăți eșuate',
    },
    tags: {
      is_high_billing_risk_customer: 'Risc ridicat de facturare',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea datelor',
    },
  },
};
